import React, { useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Breadcrumbs,
} from "@mui/material";
import {
  Settings,
  Timelapse,
  AddTask,
  HolidayVillage,
  Savings,
  CreditScore,
  EnergySavingsLeaf,
  SettingsAccessibility,
  PermIdentity,
} from "@mui/icons-material";
import { ThemeProvider } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
// configuration files
import { Permissions } from "./Permissions";
import { Loans } from "./Loans";
import { AdvanceSalary } from "./AdvanceSalary";
import { Expense } from "./Expense";
// import { DayOff } from "./Weekoff";
import { Incentive } from "./Incentive";
import { themes, sideBarWidth, theme } from "services/constants";
//customFilter
import { FilterProvider } from "../../FilterContext";
import { setFilterApi } from "services/Redux/userManagament";

//overtime updated design
import { Leaves } from "./Leaves";
import { WeekOff } from "./Weekoff";
import { OTPreApproval } from "./OverTime/OTPreApproval";
import { OTPostApproval } from "./OverTime/OTPostWorkApproval";

export const Approve = () => {
  const [selectedItem, setSelectedItem] = useState("OT Pre-Approval");
  const sideBarOpen = true;
  const [showFullPage, setShowFullPage] = useState(false);
  const { domain, userScreenAccess, userDetails } = useSelector(
    (state) => state.tokenReducer
  );

  const shiftModule = userScreenAccess?.module_details.find(
    (mod) => mod.module_name === "Approve"
  );
  const dispatch = useDispatch();
  const setReloadData = false;

  const subModuleId = shiftModule?.submodules?.find(
    (sub) => sub.sub_module_name === selectedItem
  )?.sub_module_id;

  const shiftMenuItems = [
    {
      type: "title",
      title: "Attendance Request",
    },

    {
      type: "item",
      title: "Leaves",
      key: "Leaves",
      subtitle: "Apply & approve leaves",
      icon: <HolidayVillage />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Permissions",
      key: "Permissions",
      subtitle: "Short-time requests",
      icon: <PermIdentity />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "OT Pre-Approval",
      key: "OT Pre-Approval",
      subtitle: "Review overtime requests",
      icon: <Timelapse />,
      color: "#6c757d",
    },

    {
      type: "item",
      title: "DayOff",
      key: "DayOff",
      subtitle: "Manage day-off requests",
      icon: <SettingsAccessibility />,
      color: "#6c757d",
    },

    {
      type: "title",
      title: "Payroll Request",
    },
    {
      type: "item",
      title: "OT Post-Approval",
      key: "OT Post-Approval",
      groupKey: "Group Shift Group",
      subtitle: "Finalize overtime approval",
      icon: <AddTask />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Advance Salary",
      key: "Advance Salary",
      subtitle: "Process salary advances",
      icon: <Savings />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Loans",
      key: "Loans",
      subtitle: "Manage employee loans",
      icon: <CreditScore />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Expense",
      key: "Expense",
      subtitle: "Handle expense claims",
      icon: <EnergySavingsLeaf />,
      color: "#6c757d",
    },
    {
      type: "item",
      title: "Incentive",
      key: "Incentive",
      subtitle: "Manage incentive payouts",
      icon: <Settings />,
      color: "#6c757d",
    },
  ];

  const handleShiftItemClick = (itemTitle) => {
    if (selectedItem === itemTitle) return;
    setSelectedItem(itemTitle);
    dispatch(setFilterApi(true));
    setShowFullPage(false);
  };

  const renderMainContent = () => {
    switch (selectedItem) {
      case "Leaves":
        return (
          <Leaves currentScreen={selectedItem} setReloadData={setReloadData} />
        );
      case "Permissions":
        return <Permissions setSelectedItem={setSelectedItem} />;
      case "Expense":
        return (
          <Expense
            showFullPage={showFullPage}
            setShowFullPage={setShowFullPage}
            setReloadData={setReloadData}
          />
        );

      case "DayOff":
        return (
          <WeekOff
            showFullPage={showFullPage}
            setShowFullPage={setShowFullPage}
            setReloadData={setReloadData}
          />
        );

      case "OT Pre-Approval":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <OTPreApproval />
          </FilterProvider>
        );
      case "OT Post-Approval":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <OTPostApproval />
          </FilterProvider>
        );
      case "Loans":
        return (
          <Loans
            showFullPage={showFullPage}
            setShowFullPage={setShowFullPage}
            setReloadData={setReloadData}
          />
        );

      case "Advance Salary":
        return (
          <AdvanceSalary
            showFullPage={showFullPage}
            setShowFullPage={setShowFullPage}
            setReloadData={setReloadData}
          />
        );

      case "Incentive":
        return (
          <Incentive
            showFullPage={showFullPage}
            setShowFullPage={setShowFullPage}
            setReloadData={setReloadData}
          />
        );

      default:
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <OTPostApproval />;
          </FilterProvider>
        );
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          height: "94.5vh",
          backgroundColor: themes?.whiteColor,
        }}
      >
        <Box
          sx={{
            width: sideBarOpen ? sideBarWidth : 0,
            transition: "width 0.3s ease",
            overflowX: "hidden",
            flexShrink: 0,
            mt: "10px",
            backgroundColor: themes?.whiteColor,
            borderRight: "1px solid #f5f5fd",
          }}
        >
          <List sx={{ p: 2 }}>
            {shiftMenuItems.map((item, index) =>
              item.type === "title" ? (
                <Typography
                  key={`title-${index}`}
                  variant="subtitle"
                  sx={{ fontWeight: 700, color: "#00D4AA", mt: 2, mb: 2 }}
                >
                  {item.title}
                </Typography>
              ) : (
                <ListItem key={item.title} disablePadding sx={{ mb: 1, mt: 1 }}>
                  <ListItemButton
                    onClick={() => handleShiftItemClick(item.key)}
                    sx={{
                      backgroundColor:
                        selectedItem === (item.key ?? item.groupKey)
                          ? "#f0f8ff"
                          : "transparent",
                      borderRadius: 1,
                      p: 1,
                      "&:hover": { backgroundColor: "#f8f9fa" },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "38px",
                        color:
                          selectedItem === item.key ? "#00D4AA" : item.color,
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {item.title}
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: 600 }}>
                        {item.subtitle}
                      </Typography>
                    </Box>
                  </ListItemButton>
                </ListItem>
              )
            )}
          </List>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            p: 3,
            minWidth: 0,
            backgroundColor:
              selectedItem === "OT Pre-Approval" ||
              selectedItem === "OT Post-Approval"
                ? "#f5f5fd"
                : "transparent",
            transition: "all 0.3s ease",
          }}
        >
          {(selectedItem === "OT Pre-Approval" ||
            selectedItem === "OT Post-Approval") &&
            sideBarOpen &&
            !showFullPage && (
              <Breadcrumbs aria-label="breadcrumb" separator="›" sx={{ mb: 2 }}>
                <Typography>Team Zone</Typography>
                <Typography>Approve</Typography>
                <Typography color={themes?.blueColor}>
                  {selectedItem}
                </Typography>
              </Breadcrumbs>
            )}

          {renderMainContent()}
        </Box>
      </Box>
    </ThemeProvider>
  );
};
